module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-3.346fee0d.jpg";